import { render, staticRenderFns } from "./PauseDeliveries.vue?vue&type=template&id=03320fda&"
import script from "./PauseDeliveries.vue?vue&type=script&lang=js&"
export * from "./PauseDeliveries.vue?vue&type=script&lang=js&"
import style0 from "./PauseDeliveries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports